/* eslint-disable */

/** unique or primary key constraints on table "applet.deployment" */
export enum AppletDeploymentConstraint {
  /** unique or primary key constraint on columns "deployment_id" */
  AppletDeploymentPkey = 'applet_deployment_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  AppletDeploymentUniqueName = 'applet_deployment_unique_name'
}

/** unique or primary key constraints on table "applet.deployment_linked_design_version" */
export enum AppletDeploymentLinkedDesignVersionConstraint {
  /** unique or primary key constraint on columns "deployment_linked_design_version_id" */
  AppletDeploymentLinkedDesignVersionPkey = 'applet_deployment_linked_design_version_pkey'
}

/** select columns of table "applet.deployment_linked_design_version" */
export enum AppletDeploymentLinkedDesignVersionSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  DeploymentId = 'deployment_id',
  /** column name */
  DesignVersionId = 'design_version_id',
  /** column name */
  Id = 'id'
}

/** update columns of table "applet.deployment_linked_design_version" */
export enum AppletDeploymentLinkedDesignVersionUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  DeploymentId = 'deployment_id',
  /** column name */
  DesignVersionId = 'design_version_id',
  /** column name */
  Id = 'id'
}

/** select columns of table "applet.deployment" */
export enum AppletDeploymentSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Notes = 'notes',
  /** column name */
  RunnerId = 'runner_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Version = 'version'
}

/** select "applet_deployment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "applet.deployment" */
export enum AppletDeploymentSelectColumnAppletDeploymentAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "applet_deployment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "applet.deployment" */
export enum AppletDeploymentSelectColumnAppletDeploymentAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "applet.deployment" */
export enum AppletDeploymentUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Notes = 'notes',
  /** column name */
  RunnerId = 'runner_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Version = 'version'
}

/** unique or primary key constraints on table "applet.design" */
export enum AppletDesignConstraint {
  /** unique or primary key constraint on columns "design_id" */
  AppletDesignPkey = 'applet_design_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  AppletUniqueName = 'applet_unique_name'
}

/** select columns of table "applet.design" */
export enum AppletDesignSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique'
}

/** update columns of table "applet.design" */
export enum AppletDesignUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique'
}

/** unique or primary key constraints on table "applet.design_version" */
export enum AppletDesignVersionConstraint {
  /** unique or primary key constraint on columns "design_version_id" */
  AppletDesignVersionPkey = 'applet_design_version_pkey',
  /** unique or primary key constraint on columns "version_number", "design_id" */
  AppletDesignVersionUniqueVersionNumber = 'applet_design_version_unique_version_number'
}

/** select columns of table "applet.design_version" */
export enum AppletDesignVersionSelectColumn {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DesignId = 'design_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PreviousDesignVersionId = 'previous_design_version_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

/** unique or primary key constraints on table "applet.design_version_status" */
export enum AppletDesignVersionStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  AppletDesignVersionStatusPkey = 'applet_design_version_status_pkey'
}

export enum AppletDesignVersionStatusEnum {
  Approved = 'approved',
  Retired = 'retired',
  Staged = 'staged',
  Submitted = 'submitted'
}

/** select columns of table "applet.design_version_status" */
export enum AppletDesignVersionStatusSelectColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** update columns of table "applet.design_version_status" */
export enum AppletDesignVersionStatusUpdateColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** update columns of table "applet.design_version" */
export enum AppletDesignVersionUpdateColumn {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DesignId = 'design_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PreviousDesignVersionId = 'previous_design_version_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

/** unique or primary key constraints on table "applet.privileged_audit" */
export enum AppletPrivilegedAuditConstraint {
  /** unique or primary key constraint on columns "id" */
  PrivilegedAuditPkey = 'privileged_audit_pkey'
}

/** select columns of table "applet.privileged_audit" */
export enum AppletPrivilegedAuditSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DeploymentId = 'deployment_id',
  /** column name */
  DesignVersionId = 'design_version_id',
  /** column name */
  DesignVersionNumber = 'design_version_number',
  /** column name */
  FlowId = 'flow_id',
  /** column name */
  FlowInputs = 'flow_inputs',
  /** column name */
  Id = 'id',
  /** column name */
  OperatorUserId = 'operator_user_id',
  /** column name */
  PerformedAt = 'performed_at',
  /** column name */
  PrivilegedUserId = 'privileged_user_id'
}

/** update columns of table "applet.privileged_audit" */
export enum AppletPrivilegedAuditUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DeploymentId = 'deployment_id',
  /** column name */
  DesignVersionId = 'design_version_id',
  /** column name */
  DesignVersionNumber = 'design_version_number',
  /** column name */
  FlowId = 'flow_id',
  /** column name */
  FlowInputs = 'flow_inputs',
  /** column name */
  Id = 'id',
  /** column name */
  OperatorUserId = 'operator_user_id',
  /** column name */
  PerformedAt = 'performed_at',
  /** column name */
  PrivilegedUserId = 'privileged_user_id'
}

/** unique or primary key constraints on table "applet.registration_code" */
export enum AppletRegistrationCodeConstraint {
  /** unique or primary key constraint on columns "context_id", "created_by_id" */
  RegistrationCodePkey = 'registration_code_pkey'
}

/** select columns of table "applet.registration_code" */
export enum AppletRegistrationCodeSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id'
}

/** update columns of table "applet.registration_code" */
export enum AppletRegistrationCodeUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id'
}

/** unique or primary key constraints on table "applet.runner" */
export enum AppletRunnerConstraint {
  /** unique or primary key constraint on columns "runner_id" */
  AppletRunnerPkey = 'applet_runner_pkey'
}

/** unique or primary key constraints on table "applet.runner_context" */
export enum AppletRunnerContextConstraint {
  /** unique or primary key constraint on columns "runner_context_id" */
  AppletRunnerContextPkey = 'applet_runner_context_pkey',
  /** unique or primary key constraint on columns "context_id", "runner_id" */
  AppletUniqueRunnerContext = 'applet_unique_runner_context'
}

/** select columns of table "applet.runner_context" */
export enum AppletRunnerContextSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RunnerId = 'runner_id'
}

/** update columns of table "applet.runner_context" */
export enum AppletRunnerContextUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RunnerId = 'runner_id'
}

/** select columns of table "applet.runner" */
export enum AppletRunnerSelectColumn {
  /** column name */
  ClientOrigin = 'client_origin',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HealthReceivedAt = 'health_received_at',
  /** column name */
  HealthRunner = 'health_runner',
  /** column name */
  HealthRuntimes = 'health_runtimes',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "applet.runner" */
export enum AppletRunnerUpdateColumn {
  /** column name */
  ClientOrigin = 'client_origin',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HealthReceivedAt = 'health_received_at',
  /** column name */
  HealthRunner = 'health_runner',
  /** column name */
  HealthRuntimes = 'health_runtimes',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  UpdatedAt = 'updated_at'
}

